import { ImageFragment } from "../../fragments/image";
import { gql } from "@apollo/client";

export const QUERY_FORGOT_PASSWORD_PAGE = gql`
  query forgotPasswordPage {
    forgotPassword {
      data {
        attributes {
          pageImage {
            data {
              ...ImageFragment
            }
          }
          forgotPasswordTitle
          forgotPasswordDescription
          customerEmailAddressTitle
          sendMeCta
          backToLoginCta
          chooseANewPasswordTitle
          passwordsShouldBeDescription
          yourNewPassword
          repeatYourPassword
          resetMyPasswordCta
          feedback {
            emailSent {
              title
              description
            }
            passwordResetSuccess {
              title
              description
            }
            passwordResetError {
              title
              description
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_LOGIN_PAGE = gql`
  query loginPage {
    loginPage {
      data {
        attributes {
          pageImage {
            data {
              ...ImageFragment
            }
          }
          loginTitle
          yourEmailTitle
          yourPasswordTitle
          rememberMeTitle
          loginCta
          forgotYourPasswordCta
          confirmEmailTitle
          pleaseLoginTItle
          fieldErrors {
            identifierRequired
            passwordRequired
          }
          popUpMessages {
            success {
              title
              message
            }
            error {
              title
              message
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_REGISTER_PAGE = gql`
  query registerPage {
    registerPage {
      data {
        attributes {
          registerTitle
          description
          yourEmail
          schoolCode
          yourFirstName
          yourLastName
          choosePassword
          repeatYourPassword
          createYourAccountCta
          welcomeToTItle
          pageImage {
            data {
              ...ImageFragment
            }
          }
          image {
            data {
              ...ImageFragment
            }
          }
          successRegisterPopUpTitle
          successRegisterPopUpMessage
          fieldErrors {
            surnameRequired
            forenameRequired
            emailRequired
            schoolCodeRequired
            passwordRequired
            termsAndConditionsRequired
            confirmPasswordRequired
            confirmPasswordDidNotMatch
          }
          popUpMessages {
            success {
              title
              message
            }
            error {
              title
              message
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
